import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator"; 
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator"; 


export class Sysidname { 
    @MaxLength(10,{message: 'COMPANY 字串太長'}) 
    @IsString({message: 'COMPANY 不是字串型態'}) 
    COMPANY: string = ""; 
  
    @MaxLength(10) 
    CREATOR: string = ""; 
  
    @MaxLength(10) 
    USR_GROUP: string = ""; 
  
    @MaxLength(8) 
    CREATE_DATE: string =""; 
  
    @MaxLength(10) 
    MODIFIER: string = ""; 
  
    @MaxLength(8) 
    MODI_DATE: string = ""; 
  
    @IsNumber() 
    @Max(999) 
    FLAG: number =0; 


    @IsNotEmpty({message: '欄位FIELD (SYSIDFIELD) 不可空白'}) 
    @MaxLength(12,{message: '欄位FIELD (SYSIDFIELD) 資料太長'})
    SYSIDFIELD: string = '';            // 欄位FIELD 12 

    @IsNotEmpty({message: '代號 (SYSIDID) 不可空白'}) 
    @MaxLength(2,{message: '代號 (SYSIDID) 資料太長'})
    SYSIDID: string = '';            // 代號 2 940614 MODI 1->2

    @MaxLength(20,{message: '對照名稱 (SYSIDNAME) 資料太長'})
    SYSIDNAME: string = '';            // 對照名稱 20 

    @MaxLength(30,{message: '說明 (SYSIDPS) 資料太長'})
    SYSIDPS: string = '';            // 說明 30 


}
